import type { CityConfig } from "../city-template/types";

export const rochesterHillsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Oakland County Clerk", href: "https://www.oakgov.com/clerkrod/", description: "Oakland County Clerk — marriage license issuance" },
    { label: "Divorce Records — Oakland County Clerk", href: "https://www.oakgov.com/clerkrod/", description: "Oakland County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Rochester Hills",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "rochester-hills",
  route: "/rochester-hills",
  title: "Emergency Passport Rochester Hills, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Rochester Hills, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Rochester Hills, Rochester, Auburn Hills, Lake Orion, and all northern Oakland County residents. A+ BBB rated courier service.",
  h1: "Emergency & Expedited Passport Services in Rochester Hills, MI",
  heroSubtitle: "Rochester Hills travelers — from M-59 business professionals to Rochester families to Auburn Hills automotive workers — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Northern Oakland County covered with no need to drive downtown. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Rochester%20Hills%20Michigan%20suburban%20landscape%20with%20rolling%20green%20hills%2C%20tree-lined%20residential%20streets%2C%20the%20Rochester%20Hills%20Museum%20at%20Van%20Hoosen%20Farm%2C%20modern%20commercial%20areas%20along%20M-59%20and%20Rochester%20Road%2C%20clean%20well-maintained%20affluent%20neighborhoods%2C%20soft%20afternoon%20golden%20light%2C%20northern%20Oakland%20County%20Detroit%20metro%20area%2C%20no%20text%20no%20people%2C%20professional%20suburban%20photography%2C%20calm%20and%20peaceful%20atmosphere&width=1800&height=700&seq=rochester-hills-mi-hero-001&orientation=landscape",
  heroImageAlt: "Rochester Hills Michigan suburban landscape with rolling green hills and M-59 corridor",
  geoPosition: "42.6583;-83.1499",
  geoPlacename: "Rochester Hills, Michigan",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 30 miles southeast of Rochester Hills — about 40 minutes via I-75",
  },
  nearbyCitiesZips: [
    { name: "Rochester Hills", zips: "48306, 48307, 48309" },
    { name: "Rochester", zips: "48307, 48308, 48309" },
    { name: "Auburn Hills", zips: "48321, 48326" },
    { name: "Lake Orion", zips: "48359, 48360, 48362" },
    { name: "Orion Township", zips: "48348, 48359, 48360" },
    { name: "Troy", zips: "48083, 48084, 48085, 48098, 48099" },
    { name: "Pontiac", zips: "48340, 48341, 48342, 48343" },
    { name: "Bloomfield Hills", zips: "48301, 48302, 48304" },
    { name: "Birmingham", zips: "48009, 48012" },
    { name: "Clawson", zips: "48017" },
    { name: "Royal Oak", zips: "48067, 48068, 48069, 48073" },
    { name: "Madison Heights", zips: "48071" },
    { name: "Sterling Heights", zips: "48310, 48311, 48312, 48313, 48314" },
    { name: "Warren", zips: "48088, 48089, 48091, 48092, 48093" },
    { name: "Shelby Township", zips: "48315, 48316, 48317" },
    { name: "Utica", zips: "48315, 48316, 48317" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-truck-line", title: "No Driving Downtown", desc: "Ship from Rochester Hills — our couriers handle the agency submission" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — stay home while we do the work" },
  ],
  internalLinks: [
    { name: "Expedited passport in Detroit, MI", route: "/detroit" },
    { name: "Emergency passport services in Troy, MI", route: "/troy-mi" },
    { name: "Urgent passport processing in Sterling Heights, MI", route: "/sterling-heights" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Rochester Hills, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the downtown drive. Rochester Hills residents can ship from any UPS or FedEx in northern Oakland County.",
  fpcOfficeDistance: "Serving Rochester Hills, Rochester, Auburn Hills, Lake Orion, Orion Township, Troy, Pontiac, and all northern Oakland County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Rochester Hills and northern Oakland County. From the Rochester Hills Museum at Van Hoosen Farm to the Auburn Hills Palace, from the Lake Orion waterfront to the Troy business corridor — we serve all of northern Oakland and southern Macomb counties. Our courier service is especially convenient for Rochester Hills residents who would otherwise need to drive to downtown Detroit.",
  nearbyCitiesIntro: "We serve Rochester Hills and all of northern Oakland County including Rochester, Auburn Hills, Lake Orion, Orion Township, Troy, Pontiac, Bloomfield Hills, Birmingham, Clawson, and Royal Oak. We also serve southern Macomb County including Sterling Heights, Warren, Shelby Township, and Utica.",
  howItWorksIntro: "Most Rochester Hills travelers complete everything online and ship documents overnight. No driving downtown to the Detroit Passport Agency — our registered couriers handle the agency submission for you.",
  mistakesIntro: "Rochester Hills is an affluent northern Oakland County suburb with a strong automotive and business community. Here are the most common passport mistakes we see from northern Oakland County travelers.",
  testimonialsIntro: "Rochester Hills travelers — from automotive professionals to international families to students — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Rochester Hills, MI? Here are the most common ones we hear from northern Oakland County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No driving downtown — ship from Rochester Hills", "No appointment wait — we handle submission", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must drive to downtown Detroit — 30 miles", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Rochester Hills travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute business trips, family emergencies, and international travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "No need to drive downtown to the agency"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Rochester Hills adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Rochester Hills address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Rochester Hills residents and families — including students, new citizens, and families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Rochester Hills residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Rochester Hills-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Rochester Hills residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Rochester Hills MI", description: "Urgent passport processing for Rochester Hills Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Rochester Hills MI", description: "Fast passport renewal for Rochester Hills Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Rochester Hills MI", description: "New passport application services for Rochester Hills Michigan residents applying for their first passport." },
    { name: "Child Passport Rochester Hills MI", description: "Minor passport services for Rochester Hills Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Thomas R.",
      location: "Rochester Hills, MI",
      rating: 5,
      text: "Business trip to Frankfurt in 4 days and my passport was expired. Fast Passport Center handled everything — delivered my renewed passport in 36 hours. I never left Rochester Hills. Their courier handled the Detroit agency while I was at work.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Anita K.",
      location: "Rochester, MI",
      rating: 5,
      text: "Family trip to India with 8 days notice. Four passports for our whole family. Done in 5 days. We shipped from the UPS on Rochester Road and everything went smooth. Highly recommend.",
      service: "Family Passport Bundle",
    },
    {
      name: "Greg M.",
      location: "Auburn Hills, MI",
      rating: 5,
      text: "Auto industry conference in Seoul and I realized my passport was expiring too soon. Fast Passport Center got me a renewed passport in 2 days. The process was completely hands-off from my end.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah J.",
      location: "Lake Orion, MI",
      rating: 5,
      text: "Needed to cross to Canada for a family emergency and lost my passport the day before. Fast Passport Center walked me through the process and had a replacement in my hands in 48 hours.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "rh-1",
      name: "Rochester Hills Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Rochester Rd",
      city: "Rochester Hills",
      state: "MI",
      zip: "48307",
      phone: "(248) 652-6000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Rochester Hills — near Rochester Road and M-59",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Rochester Hills acceptance facility. Ample parking. Serves Rochester Hills, Rochester, and northern Oakland County residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "rh-2",
      name: "Rochester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 E 4th St",
      city: "Rochester",
      state: "MI",
      zip: "48307",
      phone: "(248) 651-2000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Rochester — downtown Rochester, near the Paint Creek",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for downtown Rochester residents. Located in the historic downtown district. Book early — high demand during summer.",
      icon: "ri-mail-line",
    },
    {
      id: "rh-3",
      name: "Auburn Hills Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3333 Auburn Rd",
      city: "Auburn Hills",
      state: "MI",
      zip: "48326",
      phone: "(248) 373-5000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Auburn Hills — approximately 8 miles southwest of Rochester Hills",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Auburn Hills and western Rochester Hills residents. Convenient to the Auburn Hills business district. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "rh-4",
      name: "Lake Orion Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "175 S Broadway St",
      city: "Lake Orion",
      state: "MI",
      zip: "48362",
      phone: "(248) 693-3000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lake Orion — approximately 10 miles north of Rochester Hills",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lake Orion and northern Oakland County residents. Small-town office with shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "rh-5",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 30 miles southeast of Rochester Hills — about 40 minutes via I-75",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must drive 30 miles to downtown", fpc: "No — ship from Rochester Hills" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Rochester Hills residents are 30 miles from downtown Detroit and traffic on I-75 can be heavy. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Air Travel",
      description: "Many northern Oakland County residents use a passport card or enhanced license for Canada driving trips — but these are not valid for air travel. If you fly internationally, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops in Rochester Hills and Rochester sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Rochester Hills-area acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-truck-line",
      title: "Not Using a Courier for Northern Oakland County",
      description: "Northern Oakland County residents who drive themselves to the Detroit Passport Agency spend 2+ hours round-trip plus parking and waiting. A courier saves you the entire day and gets faster results.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Rochester Hills or northern Oakland County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx on Rochester Road, M-59, or in Auburn Hills, Rochester, or Lake Orion." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait or downtown drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Rochester Hills address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency for Rochester Hills residents?", a: "The nearest regional passport agency is the Detroit Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 30 miles southeast of Rochester Hills (about 40 minutes via I-75). It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can skip the appointment backlog — no need for you to drive downtown." },
    { q: "How fast can I get an emergency passport in Rochester Hills?", a: "Fast Passport Center offers emergency passport processing in Rochester Hills, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to take a day off work or drive downtown." },
    { q: "Can I get a passport at the Rochester Hills Post Office?", a: "Yes, the Rochester Hills Post Office at 1000 Rochester Rd offers passport acceptance services Monday through Friday. However, they only process routine and standard expedited applications via mail. For emergency processing within 2 weeks, you will need either an appointment at the Detroit Passport Agency or Fast Passport Center's courier service." },
    { q: "Does Fast Passport Center serve Rochester and Auburn Hills?", a: "Absolutely. Fast Passport Center serves all of northern Oakland County including Rochester Hills, Rochester, Auburn Hills, Lake Orion, Orion Township, Troy, Pontiac, Bloomfield Hills, and Birmingham. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Rochester Hills-area travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for Rochester Hills-area travelers — approximately 35 miles south via I-75 and I-275. DTW offers direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Oakland County International Airport (PTK) in Waterford is primarily general aviation." },
    { q: "How much does an expedited passport cost in Rochester Hills, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Rochester Hills residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Rochester Hills, Rochester, and Auburn Hills offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Do I need to drive to Detroit for my passport?", a: "No. With Fast Passport Center, you never need to drive to Detroit. We handle everything by courier. You complete your application online, ship your documents from any Rochester Hills-area UPS or FedEx, and our registered courier takes them to the Detroit Passport Agency for you. Your new passport is shipped back to your address." },
  ],
  photoLocations: [
    { name: "Walgreens — Rochester Hills", address: "2910 S Rochester Rd, Rochester Hills, MI 48307", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Rochester Hills", address: "2880 S Rochester Rd, Rochester Hills, MI 48307", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Rochester Hills", address: "2020 S Rochester Rd, Rochester Hills, MI 48307", hours: "Mon–Fri: 8AM–6:30PM, Sat: 9AM–4PM" },
    { name: "Walgreens — Auburn Hills", address: "3415 Auburn Rd, Auburn Hills, MI 48326", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Rochester Hills", address: "3030 S Rochester Rd, Rochester Hills, MI 48307", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Auburn Hills", address: "3375 Auburn Rd, Auburn Hills, MI 48326", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Auburn Hills and western Rochester Hills communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 35 miles south via I-75 and I-275 — about 40–45 minutes",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Rochester Hills-area travelers. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "PTK",
      name: "Oakland County International Airport",
      distance: "Approximately 15 miles west via M-59 — general aviation",
      address: "6500 Highland Rd, Waterford, MI 48327",
      note: "Primarily general aviation with some regional charter flights. Not used for scheduled international travel. DTW remains the main gateway for international departures.",
      flightUrl: "https://www.oakgov.com/aviation/",
      flightLabel: "PTK Airport Info",
      featured: false,
    },
    {
      code: "ARB",
      name: "Ann Arbor Municipal Airport",
      distance: "Approximately 35 miles southwest via M-59 and I-96 — general aviation only",
      address: "801 Airport Dr, Ann Arbor, MI 48108",
      note: "General aviation airport with no scheduled commercial service. Not used for international travel.",
      flightUrl: "https://www.annarborairport.com/",
      flightLabel: "ARB Airport Info",
      featured: false,
    },
  ],
};